module.exports = __webpack_public_path__ + "img/bg-sign-out-offline.c65ca04e.png";